import { useAuth0 } from '@auth0/auth0-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'
import { getApplicationLocaleCode } from '~/locales'
import { svgUrl } from '~/utils'

import styles from './PublicTopPage.css'

const lng = getApplicationLocaleCode()

export const PublicTopPage = () => {
  const { t } = useTranslation()
  const { loginWithRedirect } = useAuth0()
  const handleLoginButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    loginWithRedirect({ appState: { returnTo: window.location.pathname } })
  }, [loginWithRedirect])

  useLogEventOnMount('Access to 9segs analyzer', {
    deviceId: btoa(
      encodeURIComponent(
        `${window.navigator.userAgent} ${window.screen.height} ${window.screen.width} ${window.screen.pixelDepth} ${window.screen.colorDepth}`,
      ),
    ),
  })

  return (
    <VStack align="center" className={styles.root} spacing={8}>
      <VStack align="center" spacing={4}>
        <img alt="logo" src={svgUrl('logo')} />

        <Typography fontSize={16} variant="normal">
          by M-Force
        </Typography>
      </VStack>

      <StyledButton
        className={styles.loginButton}
        onClick={handleLoginButtonClick}
      >
        <Typography color="inherit" variant="heading1">
          {t('login', {
            lng,
          })}
        </Typography>
      </StyledButton>
    </VStack>
  )
}
